import { render } from "./DDChatFilter.vue?vue&type=template&id=481a0e62"
import script from "./DDChatFilter.vue?vue&type=script&lang=js"
export * from "./DDChatFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__